import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Window from '../Window';
import { 
  Play, 
  Pause, 
  SkipBack, 
  SkipForward, 
  Shuffle,
  Repeat,
  Plus,
  MoreHorizontal,
  Heart,
  ExternalLink
} from 'lucide-react';

const MusicContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #121212;
  border-radius: 12px;
  padding: 20px;
  color: white;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const SpotifyLogo = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #1DB954;
`;

const PlaylistEmbed = styled.div`
  flex: 1;
  margin-bottom: 16px;
  border-radius: 8px;
  overflow: hidden;
  background: #282828;
`;

const PlaylistInfo = styled.div`
  margin-bottom: 16px;
`;

const PlaylistTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
`;

const PlaylistCreator = styled.div`
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 8px;
`;

const OpenSpotifyButton = styled.button`
  background: #1DB954;
  border: none;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  
  &:hover {
    background: #1ed760;
  }
`;

const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;

const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 14px;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
  
  &.play-pause {
    background: #1DB954;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      background: #1ed760;
    }
  }
`;

const SpotifyApp = ({ ...windowProps }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const [playlistUrl, setPlaylistUrl] = useState('');


  const spotifyPlaylistUrl = 'https://open.spotify.com/playlist/2nnxjA4u8pw4ihf9nwMoVi?si=Bqs2ub_4Sa2efxTs-tlA0A&pi=T5LNhZjhRu-ad';

  useEffect(() => {
   
    const urlMatch = spotifyPlaylistUrl.match(/playlist\/([a-zA-Z0-9]+)/);
    if (urlMatch) {
      const playlistId = urlMatch[1];
      setPlaylistUrl(`https://open.spotify.com/embed/playlist/${playlistId}`);
    }
  }, []);

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
    // for future use
  };

  const handleLike = () => {
    setIsLiked(!isLiked);
  };

  const handleOpenSpotify = () => {
    window.open(spotifyPlaylistUrl, '_blank');
  };

  return (
    <Window {...windowProps} size={{ width: 400, height: 500 }}>
      <MusicContainer>
        <Header>
          <SpotifyLogo>Spotify</SpotifyLogo>
          <ControlButton onClick={handleLike}>
            <Heart size={16} fill={isLiked ? "#1DB954" : "none"} color={isLiked ? "#1DB954" : "white"} />
          </ControlButton>
        </Header>
        
        <PlaylistEmbed>
          {playlistUrl ? (
            <iframe
              src={playlistUrl}
              width="100%"
              height="200"
              frameBorder="0"
              allow="encrypted-media"
              title="Spotify Playlist"
            />
          ) : (
            <div style={{ 
              height: '200px', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              background: '#282828',
              color: '#b3b3b3'
            }}>
              Loading playlist...
            </div>
          )}
        </PlaylistEmbed>
        
        <PlaylistInfo>
          <PlaylistTitle>It's Alt Good • Aviral</PlaylistTitle>
          <PlaylistCreator>Playlist by Aviral Malik</PlaylistCreator>
          <OpenSpotifyButton onClick={handleOpenSpotify}>
            <ExternalLink size={12} />
            Open in Spotify
          </OpenSpotifyButton>
        </PlaylistInfo>
        
        <Controls>
          <ControlButton>
            <Shuffle size={14} />
          </ControlButton>
          <ControlButton>
            <SkipBack size={14} />
          </ControlButton>
          <ControlButton className="play-pause" onClick={handlePlayPause}>
            {isPlaying ? <Pause size={16} /> : <Play size={16} />}
          </ControlButton>
          <ControlButton>
            <SkipForward size={14} />
          </ControlButton>
          <ControlButton>
            <Repeat size={14} />
          </ControlButton>
        </Controls>
      </MusicContainer>
    </Window>
  );
};

export default SpotifyApp;
